import {
  TRACKER_MESSAGE_HISTORY_RECORD_STATE,
  TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND,
  type TrackerMessage,
  type TrackerMessageOverview,
} from '@racemap/sdk/schema/trackers';
import { getMessageState } from '@racemap/utilities/functions/messages';
import type { Immutable } from 'immer';
/**
 * Returns true if this message is as a failure:
 *  - it’s in an ERROR state,
 *  - it wasn’t acknowledged when server‐acks are enabled,
 *  - or it wasn’t sent.
 */
export const isFailedMessage = (
  message: Immutable<TrackerMessageOverview | TrackerMessage>,
): boolean =>
  StateNumberMapping[getMessageState(message)] === StateNumberMapping.ERROR ||
  getMessageState(message) === TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND.NOT_ACKNOWLEDGED ||
  getMessageState(message) === TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND.NOT_SENT;

export const StateNumberMapping: Record<string, number> = {
  UNKNOWN: 0,
  NO_NEW_MESSAGE: 1,
  [TRACKER_MESSAGE_HISTORY_RECORD_STATE.REVOKED]: 2,
  [TRACKER_MESSAGE_HISTORY_RECORD_STATE.CLEARED]: 3,
  REQUESTED: 4,
  SCHEDULED: 5,
  [TRACKER_MESSAGE_HISTORY_RECORD_STATE.COMPLETE]: 6,
  [TRACKER_MESSAGE_HISTORY_RECORD_STATE.SENT]: 7,
  [TRACKER_MESSAGE_HISTORY_RECORD_STATE.DELIVERED]: 8,
  [TRACKER_MESSAGE_HISTORY_RECORD_STATE.ERROR]: 9,
  NOT_SENT: 10,
  NOT_ACKNOWLEDGED: 11,
};
